module.exports = __webpack_public_path__ + "static/media/fanball.0f432bd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/fanball.svg
// module id = 106
// module chunks = 0